export const researchApiData = {
  'researchTopicList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教师研修(微课)', '获取系列下所有主题'],
    title: '获取系列下所有主题', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取系列下所有主题', url: '/api/v1/invoke-v2/teacherResearch/getSeries', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '系列id' },
        { paras: 'name', type: 'String', description: '系列名称' },
        { paras: 'introduction', type: 'String', description: '系列介绍' },
        { paras: 'jyRelationTopicalList', type: 'Array', description: '系列下的主题' },
        { paras: 'jyRelationTopicalList->id', type: 'Int', description: '主题id' },
        { paras: 'jyRelationTopicalList->name', type: 'String', description: '主题名称' },
        { paras: 'jyRelationTopicalList->stageId', type: 'Int', description: '主题所属学段' },
        { paras: 'jyRelationTopicalList->coverUrl', type: 'String', description: '主题缩略图' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "id": 2,
          "createdTime": "2023-05-18T11:43:12",
          "modifiedTime": "2023-08-22T09:33:02",
          "name": "微点教学",
          "introduction": "111",
          "ordinal": 1,
          "creator": "xxx",
          "jyRelationTopicalList": [
            {
              "id": 42,
              "name": "小学数学",
              "stageId": 2,
              "coverUrl": "http://jty-prefecture-banner-new.obs.cn-north-4.myhuaweicloud.com/teaching/2023-5-18/2023051832254215.jpg"
            },
            {
              "id": 43,
              "name": "小学英语",
              "stageId": 2,
              "coverUrl": "http://jty-prefecture-banner-new.obs.cn-north-4.myhuaweicloud.com/teaching/2023-5-18/2023051897736175.jpg"
            },
            {
              "id": 44,
              "name": "小学思品",
              "stageId": 2,
              "coverUrl": "http://jty-prefecture-banner-new.obs.cn-north-4.myhuaweicloud.com/teaching/2023-5-18/2023051815179188.jpg"
            }
          ]
        }
      ]
    }
    `
  },
  'researchTopicDetail': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教师研修(微课)', '获取主题详情和主题课程'],
    title: '获取主题详情和主题课程', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取主题详情和主题课程', url: '/api/v1/invoke-v2/teacherResearch/getAllCourses', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'topicalId', type: 'Int', required: '必填', description: '主题id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '主题id' },
        { paras: 'name', type: 'String', description: '主题名称' },
        { paras: 'stageId', type: 'Int', description: '主题学段id' },
        { paras: 'introduction', type: 'String', description: '主题介绍' },
        { paras: 'coverUrl', type: 'String', description: '主题封面' },
        { paras: 'categoryDTOS', type: 'String', description: '主题下课程名称列表' },
        { paras: 'courseMap', type: 'String', description: '主题下课程列表' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "id": 72,
        "createdTime": "2023-05-18T14:23:52",
        "modifiedTime": "2023-05-18T14:23:52",
        "name": "高中视频",
        "stageId": 4,
        "stageName": "高中",
        "introduction": "xxxxx",
        "ordinal": 68,
        "coverUrl": "https://jty-prefecture-banner-new.obs.cn-north-4.myhuaweicloud.com/teaching/2023-5-18/2023051877916430.jpg",
        "shelved": true,
        "useBeginDate": "2023-05-18",
        "source": 1,
        "style": 0,
        "show": true,
        "backPhoto": "http://jty-prefecture-banner-new.obs.cn-north-4.myhuaweicloud.com/teaching/2023-5-18/2023051824259180.jpg",
        "pageLink": "",
        "creatorId": 124,
        "creator": "xxx",
        "categoryDTOS": [
          {
            "id": 22,
            "name": "三门",
            "ordinal": 1
          },
          {
            "id": 23,
            "name": "文科",
            "ordinal": 2
          }
        ],
        "courseMap": {
          "三门": [
            {
              "id": 1018,
              "name": "高中英语",
              "subjectId": ",28,",
              "subjectName": "英语",
              "stageId": 4,
              "stageName": null,
              "typeId": 5,
              "typeName": null,
              "coverUrl": null,
              "creator": null,
              "creatorId": null,
              "createdTime": "2023-05-18 16:35:05",
              "updateTime": null,
              "collectNum": null,
              "downloadNum": null,
              "categoryDto": null,
              "ordinal": null,
              "isRelation": null,
              "totalIntegral": 0,
              "discountIntegral": 0,
              "videoNum": null,
              "show": true,
              "collected": false,
              "introduction": "高中",
              "buy": false,
              "famousTeacherDTO": null,
              "teachingResearchTopicalId": null
            }
          ],
          "文科": [
            {
              "id": 1024,
              "name": "高中地理",
              "subjectId": ",34,",
              "subjectName": "地理",
              "stageId": 4,
              "stageName": null,
              "typeId": 5,
              "typeName": null,
              "coverUrl": null,
              "creator": null,
              "creatorId": null,
              "createdTime": "2023-05-18 16:35:05",
              "updateTime": null,
              "collectNum": null,
              "downloadNum": null,
              "categoryDto": null,
              "ordinal": null,
              "isRelation": null,
              "totalIntegral": 0,
              "discountIntegral": 0,
              "videoNum": null,
              "show": true,
              "collected": false,
              "introduction": "高中",
              "buy": false,
              "famousTeacherDTO": null,
              "teachingResearchTopicalId": null
            }
          ]
        }
      }
    }
    `
  },
  'researchCouseDetail': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教师研修(微课)', '获取课程详情'],
    title: '获取课程详情', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取课程详情', url: '/api/v1/invoke-v2/teacherResearch/getCourseDetail', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'courseId', type: 'Int', required: '必填', description: '课程id' },
        { paras: 'topicalId', type: 'Int', required: '必填', description: '主题id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '课程id' },
        { paras: 'name', type: 'String', description: '课程名称' },
        { paras: 'coverUrl', type: 'String', description: '课程缩略图' },
        { paras: 'introduction', type: 'String', description: '课程介绍' },
        { paras: 'famousTeacherDTO', type: 'Object', description: '是否名师信息， null为没有，存在famousTeacherDTO.id则有' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "id": 1017,
        "name": "高中数学",
        "subjectId": ",27,",
        "subjectName": "数学",
        "stageId": 4,
        "stageName": null,
        "typeId": 5,
        "typeName": "素材",
        "coverUrl": null,
        "creator": null,
        "creatorId": null,
        "createdTime": "2023-05-18 16:35:04",
        "updateTime": null,
        "collectNum": null,
        "downloadNum": null,
        "categoryDto": null,
        "ordinal": null,
        "isRelation": null,
        "totalIntegral": 0,
        "discountIntegral": 0,
        "videoNum": null,
        "show": true,
        "collected": false,
        "introduction": "高中",
        "buy": false,
        "famousTeacherDTO": {
            "id": 7,
            "name": "李长建",
            "position": "九科星教研与质量部主任",
            "teacherPhoto": "http://jty-prefecture-banner.obs.cn-north-4.myhuaweicloud.com/famousTeacherPhoto/2021-1-21/2021012182935033.png",
            "teacherIntroduces": "中学语文高级教师，研究生学历，讲师团金牌讲师，九科星高级教研员，，江西三端科技研究分院院长，九科星教研与质量部主任。《作文与考试》杂志顾问，著名高考命题与研究专家。多年从事高考命题与考试研究工作，在全国各地进行高效课堂与高考备考讲座500多场，深受一线师生好评。",
            "lectureTopic": "《高考命题研究与备考策略（大课与语文学科）》《高三一轮备考与二轮备考（大课与语文学科）》《高效课堂操作与小组建设》《新高考与新对策》《听评课及课型课堂教学模式指导》等。"
        },
        "teachingResearchTopicalId": null
      }
    }
    `
  },
  'researchCourseTeacherDetail': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教师研修(微课)', '获取课程名师详情'],
    title: '获取课程名师详情', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取课程名师详情', url: '/api/v1/invoke-v2/teacherResearch/getRelationTeacher', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'courseId', type: 'Int', required: '必填', description: '课程id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '名师id' },
        { paras: 'name', type: 'String', description: '名师名称' },
        { paras: 'position', type: 'String', description: '名称头衔' },
        { paras: 'teacherPhoto', type: 'String', description: '名师头像' },
        { paras: 'teacherIntroduces', type: 'String', description: '名师简介' },
        { paras: 'lectureTopic', type: 'String', description: '名师课题' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
          "id": 7,
          "name": "李长建",
          "position": "九科星教研与质量部主任",
          "teacherPhoto": "http://jty-prefecture-banner.obs.cn-north-4.myhuaweicloud.com/famousTeacherPhoto/2021-1-21/2021012182935033.png",
          "teacherIntroduces": "中学语文高级教师，研究生学历，讲师团金牌讲师，九科星高级教研员，，江西三端科技研究分院院长，九科星教研与质量部主任。《作文与考试》杂志顾问，著名高考命题与研究专家。多年从事高考命题与考试研究工作，在全国各地进行高效课堂与高考备考讲座500多场，深受一线师生好评。",
          "lectureTopic": "《高考命题研究与备考策略（大课与语文学科）》《高三一轮备考与二轮备考（大课与语文学科）》《高效课堂操作与小组建设》《新高考与新对策》《听评课及课型课堂教学模式指导》等。"
      }
    }
    `
  },
  'researchCourseNodes': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教师研修(微课)', '获取课程下的目录'],
    title: '获取课程下的目录', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取课程下的目录', url: '/api/v1/invoke-v2/teacherResearch/getNodes', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'courseId', type: 'Int', required: '必填', description: '课程id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'dtoList', type: 'Array', description: '目录list' },
        { paras: 'dtoList->id', type: 'Int', description: '目录id' },
        { paras: 'dtoList->name', type: 'String', description: '目录名称' },
        { paras: 'dtoList->children', type: 'Array', description: '子目录' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "show": true,
        "dtoList": [
          {
            "id": 10158,
            "name": "基础知识",
            "children": [
              {
                "id": 10165,
                "name": "语言表达",
                "children": null
              },
              {
                "id": 10164,
                "name": "文学文化常识",
                "children": null
              }
            ]
          }
        ]
      }
    }
    `
  },
  'researchCourseVideos': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教师研修(微课)', '获取课程目录下的视频列表'],
    title: '获取课程目录下的视频列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取课程目录下的视频列表', url: '/api/v1/invoke-v2/teacherResearch/getVideoList', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'courseId', type: 'Int', required: '必填', description: '课程id' },
        { paras: 'courseNodeId', type: 'Int', required: '非必填', description: '目录id' },
        { paras: 'isThisNode', type: 'Int', required: '必填', description: '固定 0' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '每页条数' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'content ', type: 'Array', description: '视频列表' },
        { paras: 'totalElements ', type: 'Int', description: '视频总数' },
        { paras: 'totalPages ', type: 'Int', description: '视频总页数' },
        { paras: 'size ', type: 'Int', description: '每页条数' },
        { paras: 'content->id', type: 'Int', description: '视频id' },
        { paras: 'content->name ', type: 'String', description: '视频名称' },
        { paras: 'content->videoId ', type: 'String', description: '视频播放id' },
        { paras: 'content->coverUrl ', type: 'String', description: '缩略图' },
        { paras: 'content->size ', type: 'Int', description: '视频大小' },
        { paras: 'content->videoPlayNum ', type: 'Int', description: '播放次数' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "content": [
          {
            "id": 15766,
            "name": "与人交流注意对象、场合，用语文明得体1",
            "videoId": "cbca673d6756454b8f146ede92a640d4",
            "coverUrl": "https://video.jkxjxw.com/cbca673d6756454b8f146ede92a640d4/snapshots/3dd8688fa7ad4ab5a832bbcda279eb44-00003.jpg",
            "size": 6055984,
            "integral": 0,
            "free": true,
            "courseName": null,
            "courseVideoScoreDTO": {
              "scoreUserNum": 0,
              "avgScore": 0,
              "userScore": 0
            },
            "videoPlayNum": 13,
            "buy": null
          }
        ],
        "pageable": {
          "sort": {
            "sorted": true,
            "unsorted": false
          },
          "pageSize": 10,
          "pageNumber": 0,
          "offset": 0,
          "paged": true,
          "unpaged": false
        },
        "totalElements": 1,
        "totalPages": 1,
        "last": true,
        "first": true,
        "sort": {
          "sorted": true,
          "unsorted": false
        },
        "numberOfElements": 10,
        "size": 10,
        "number": 0
      }
    }
    `
  },
  'researchVideoAddress': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '教师研修(微课)', '获取视频完整播放链接'],
    title: '获取视频完整播放链接', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取视频完整播放链接', url: '/api/v1/invoke-v2/teacherResearch/video/wholeAddress', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'videoId', type: 'Int', required: '必填', description: '视频id（是列表接口里的id）' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'playInfoList ', type: 'Array', description: '视频播放信息' },
        { paras: 'playInfoList->playURL ', type: 'String', description: '视频播放地址（具体播放方式参考视频播放实例）' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "requestId": "84F0B889-BF48-5D4B-928C-1E808572A094",
        "playInfoList": [
          {
            "width": 1440,
            "height": 960,
            "size": 16159906,
            "playURL": "https://video.jkxjxw.com/sv/214268cb-17e67c03fdb/214268cb-17e67c03fdb.mp4",
            "bitrate": "423.553",
            "definition": "OD",
            "duration": "305.225",
            "format": "mp4",
            "fps": "10.0",
            "encrypt": 0,
            "plaintext": null,
            "complexity": null,
            "streamType": "video",
            "rand": null,
            "jobId": "445953be5bea4534a189f6f47f513a8d02",
            "preprocessStatus": "UnPreprocess",
            "watermarkId": null,
            "status": "Normal",
            "creationTime": "2022-01-17T11:15:59Z",
            "modificationTime": "2022-01-17T11:15:59Z",
            "encryptType": null,
            "narrowBandType": "0",
            "specification": "Original"
          }
        ],
        "videoBase": {
          "outputType": "cdn",
          "coverURL": "https://video.jkxjxw.com/445953be5bea4534a189f6f47f513a8d/snapshots/5d90a9f7bac146d185248f8326d3bac3-00003.jpg",
          "duration": "305.225",
          "status": "Normal",
          "title": "《端午的鸭蛋》",
          "videoId": "445953be5bea4534a189f6f47f513a8d",
          "mediaType": "video",
          "creationTime": "2022-01-17T11:15:59Z",
          "transcodeMode": "NoTranscode",
          "thumbnailList": []
        }
      }
    }
    `
  }
}



// WEBPACK FOOTER //
// ./src/pages/front/documentV2/researchApiData.js